import React, { useState, useCallback, useEffect } from "react";
import { connect } from "react-redux";
import { Button } from 'devextreme-react';
import { LoadPanel } from 'devextreme-react/load-panel';
import axios from "axios";
import data from "../../../assets/apiRoutes.json";

function FMTransHeader(props) {
    var accessToken = props.oidc.user.access_token;
    const [transaction, setTransaction] = useState(null);
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [showIndicator, setShowIndicator] = useState(true);
    const [shading, setShading] = useState(true);
    const [showPane, setShowPane] = useState(true);
    const [hideOnOutsideClick, setHideOnOutsideClick] = useState(false);
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    const tableStyle = {
        width: "100%",
        borderCollapse: "collapse",
        textAlign: "center",
    };

    const thTdStyle = {
        border: "1px solid lightgray",
        padding: "8px",
        textAlign: "center",
    };

    const leftColumnStyle = {
        borderTop: "none",
        borderLeft: "none",
        borderBottom: "1px solid lightgray",
        borderRight: "1px solid lightgray",
        padding: "8px",
        textAlign: "center",
        fontWeight: "bold" // make text bold
    };

    const topLeftStyle = {
        border: "none",
        padding: "8px",
        fontWeight: "bold" // make top-left labels bold if needed
    };

    const buttonContainerStyle = {
        marginTop: "10px",
        textAlign: "right"
    };
    const handleClose = () => {
        props.setShowFMTransHeader(false);
    }
    const GetInfoById = async (id) => {
        try {
            setLoadPanelVisible(true);
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/${data.FM.GetTransHeader}?transactionId=${props.TransactionHeaderRowId}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });
            const responseData = response.data;
            console.log(responseData);
            setTransaction(response.data);
        } catch (error) {
            console.error('Error fetching item detail:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };
    useEffect(() => {
        GetInfoById(props.TransactionHeaderRowId);
    }, [props.TransactionHeaderRowId]);
    return (
        <div>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={position}
                onHiding={hideLoadPanel}
                visible={loadPanelVisible}
                showIndicator={showIndicator}
                shading={shading}
                showPane={showPane}
                hideOnOutsideClick={hideOnOutsideClick}
            />
            <table style={tableStyle}>
                <thead>
                    <tr>
                        <th style={topLeftStyle}></th>
                        <th style={thTdStyle}>Record #</th>
                        <th style={thTdStyle}>Trans/Tracking #</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={topLeftStyle}>Dispatch Object</td>
                        <td style={thTdStyle}> {transaction?.DispatchObjectRecordNumber?.trim() || "-"}</td>
                        <td style={thTdStyle}>
                            {transaction?.TrackingNumber?.trim() || "-"}
                        </td>
                    </tr>
                    <tr>
                        <td style={topLeftStyle}>Freight Bill</td>
                        <td style={thTdStyle}> {transaction?.RecordNumber?.trim() || "-"}</td>
                        <td style={thTdStyle}>
                            {transaction?.TransactionNumber?.trim() || "-"}
                        </td>
                    </tr>
                </tbody>
            </table>
            <div style={buttonContainerStyle}>
                <Button className="accordianButton" onClick={handleClose} text="Close" />
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(FMTransHeader);
